<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="article"
    :parentId="$route.params.id"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/article";
export default {
  data: () => ({
    modelName: "article_version",
    label: "法條版本",
    fields: model.fields.last_version.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "法條內容",
              fields: [
                "no_number",
                "announce_at",
                "effect_at",
                "attaches",
                "reference_link",
                "effects",
                "is_active",
                "status",
                "locales",
              ],
            },
          ],
        },
      ],
      secondary: [],
    },
  }),
};
</script>